import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './styles/container.css';
import gridStyles from './styles/grid.css';

export const gridTypes = PropTypes.oneOf([
  'standard',
  'wide',
  'wideLegacy',
  'fullScreen',
  'legacy',
]);

export const propTypes = {
  /** inserts Grid content – should be Rows */
  children: PropTypes.node,
  /** adds custom className to Grid */
  className: PropTypes.string,
  /** Defines basic Grid dimensions:
   * - `type="wide"` renders with a max-width of `1224px`
   * - `type="legacy"` renders with the classic XING breakpoints and the old adaptive steps.
   * - `type="wideLegacy"` renders a wide container with the classic XING breakpoints and the old adaptive steps.
   * - `type="standard"` renders with the classic XING breakpoints to fit into the XING frame.
   * - `type="fullScreen"` renders a wider HD size of `2000px`.
   */
  type: gridTypes,
  debug: PropTypes.bool,
};

const GridContainer = ({
  type = 'standard',
  className = '',
  children,
  ...other
}) => {
  const classes = classnames(
    styles.gridContainer,
    styles[`${type}GridContainer`],
    gridStyles[`${type}GridContainer`],
    className
  );

  return (
    <div key="container" className={classes} {...other}>
      {children}
    </div>
  );
};

GridContainer.displayName = 'GridContainer';
GridContainer.propTypes = propTypes;

export default GridContainer;
